import { render, staticRenderFns } from "./QuestionBankDetails.vue?vue&type=template&id=100dcbd0&scoped=true&"
import script from "./QuestionBankDetails.vue?vue&type=script&lang=js&"
export * from "./QuestionBankDetails.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBankDetails.vue?vue&type=style&index=0&id=100dcbd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100dcbd0",
  null
  
)

export default component.exports